import { render } from "./Question.vue?vue&type=template&id=c8f09128&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=c8f09128&scoped=true&lang=css"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f09128"]])

export default __exports__